import { useEffect, useState } from 'react'
import { getConfig, onListChange } from '../../../modules/appointment'
import { getAllBlock, getAvalibleBlocks, toString, getStringTime, filterTimesPast, getStringHourFormat12 } from '../../../helpers/date'
import { addMinutes } from 'date-fns'

const useApointmentCalculator = (appointmentDate) => {
  const [day, setDay] = useState(new Date())
  const [config, setConfig] = useState({ interval: 30, init: new Date(), saturdayInit: new Date(), saturdayEnd: new Date(), end: new Date(), loading: true })
  var [appointments, setAppointments] = useState([])
  const [visualHour, setVisualHour] = useState(null)
  const [date, setDate] = useState(appointmentDate || null)

  // allow my own appointment
  if (appointmentDate) {
    appointments = appointments.filter(apointment => {
      return apointment.date.getTime() !== appointmentDate.getTime()
    })
  }

  // delete apointments not finished after interval
  appointments = appointments.filter(appointment => {
    if (appointment.isFinished === false) {
      const currentDate = new Date()
      const operationDate = addMinutes(appointment.operationDate, config.interval)
      return operationDate.getTime() > currentDate.getTime()
    }
    return true
  })

  // // delete apointments complete but not payed after 24 Hours
  // appointments = appointments.filter(appointment => {
  //   if (appointment.isFinished === true && !appointment.isPaid) {
  //     const currentDate = new Date()
  //     const operationDate = addMinutes(appointment.operationDate, 2880)
  //     return operationDate.getTime() > currentDate.getTime()
  //   }
  //   return true
  // })

  const initCalculated = day.getDay() === 6 ? config.saturdayInit : config.init
  const endCalculated = day.getDay() === 6 ? config.saturdayEnd : config.end

  const allBlocks = getAllBlock(initCalculated, endCalculated, config.interval, day)
  var availableBlocks = getAvalibleBlocks(allBlocks, appointments)
  availableBlocks = filterTimesPast(availableBlocks)
  const availableHours = availableBlocks.reduce((cumulator, current) => ({ ...cumulator, [current.stringHour]: current.stringHour }), {})

  const handleHourChange = (event) => {
    setVisualHour(event.target.value)
    const appointmentSelected = new Date(day.getTime())
    appointmentSelected.setHours(event.target.value.split(':')[0])
    appointmentSelected.setMinutes(event.target.value.split(':')[1])
    setDate(appointmentSelected)
  }

  const handleChangeDay = (date) => {
    setVisualHour(null)
    setDay(date)
    setDate(null)
  }

  const handleFetch = async () => {
    const configFetched = await getConfig()
    setConfig({ ...configFetched, loading: false })
  }

  useEffect(() => {
    handleFetch()
    const unsubscribe = onListChange(data => setAppointments(data), toString(day))
    return () => unsubscribe()
  }, [day])

  // sync appointment date width props
  useEffect(() => {
    if (appointmentDate) {
      setDay(appointmentDate)
      setVisualHour(getStringTime(appointmentDate))
    }
  }, [toString(appointmentDate), getStringTime(appointmentDate)])

  return {
    handleChangeDay,
    day,
    availableHours,
    handleHourChange,
    hour: visualHour,
    date,
    interval: config.interval,
    init: getStringHourFormat12(config.init),
    end: getStringHourFormat12(config.end),
    saturdayEnd: getStringHourFormat12(config.saturdayEnd),
    saturdayInit: getStringHourFormat12(config.saturdayInit),
    config
  }
}

export default useApointmentCalculator
